import styled, { css } from 'styled-components';

import { gridSizes, media, zIndexses } from 'utils/style';
import Stop from './Stop.js';

export default styled(Stop)`
  /* TODO */
  background-color: var(--grey100);
  border: 1px solid #d5dee3;
  border-radius: ${gridSizes('S')};
  padding: ${gridSizes('M')} 0;
  padding-top: 0;
  margin-bottom: ${gridSizes('L')};
  position: relative;

  .header {
    grid-column: span 12;
    -ms-grid-column: 2;
    -ms-grid-column-span: 24;

    .title {
      padding-top: ${gridSizes('M')};
      grid-column: span 6;
      line-height: normal;
      width: calc(100% - ${gridSizes('M')} - ${gridSizes('M')});
      justify-self: center;
      ${media.lessThan('small')`
      grid-column: span 6;
      -ms-grid-column: 1;
      -ms-grid-column-span: 7;
      width: auto;
      justify-self: auto;
      font-size: 20px;
    `};
    }
  }

  .extraInfo {
    display: flex;
    flex-direction: column;
    line-height: normal;
    justify-self: center;
    align-items: flex-start;
    padding: ${gridSizes('M')} ${gridSizes('M')} 0;
    ${media.lessThan('extraSmall')`
      padding: ${gridSizes('M')} ${gridSizes('S')} 0;
    `};
  }

  .palletInfo {
    margin: 0 ${gridSizes('M')} 0 0;
    color: var(--grey700);
    ${media.lessThan('extraSmall')`
      display: none;
    `};
    /* max-width: 50%; */
  }

  .field {
    grid-column: span 3;
    -ms-grid-column: 2;
    -ms-grid-column-span: 6;
    -ms-grid-row: 2;
    &.first {
      -ms-grid-column: 2;
      -ms-grid-column-span: 11;
    }
    &.second {
      -ms-grid-column: 13;
      border: 1px solid transparent;
    }
    &.last {
      -ms-grid-column: 20;
    }

    ${media.lessThan('small')`
      grid-column: span 6;
      -ms-grid-column: 1;
      -ms-grid-column-span: 6;
    `};

    input {
      z-index: ${zIndexses.stopInput};
    }

    label {
      z-index: ${zIndexses.stopLabel};
    }
  }

  .address {
    grid-column: span 6;
    -ms-grid-column-span: 11;
  }

  .first {
    justify-self: right;
  }

  .first,
  .last {
    width: calc(100% - ${gridSizes('M')});
    ${media.lessThan('small')`
      width: auto;
      justify-self: auto;
    `};
  }

  .grid {
    width: 100%;
    display: grid;
    display: -ms-grid;
    grid-template-columns: repeat(12, 1fr);
    /* prettier-ignore */
    -ms-grid-columns: ${gridSizes('M')} (1fr ${gridSizes('M')})[12];
    grid-gap: ${gridSizes('M')};

    ${media.lessThan('small')`
      grid-template-columns: repeat(6, 1fr);
      -ms-grid-columns: ${gridSizes('S')} (1fr ${gridSizes('S')})[6];
      grid-gap: ${gridSizes('M')} ${gridSizes('S')};
      padding: 0 ${gridSizes('S')};
    `};
  }

  .deleteContainer {
    grid-column: span 6;
    text-align: right;
    padding-right: 8px;
    padding-top: 8px;
  }

  .appointment {
    grid-column: span 6;
    padding-right: 16px;

    .link {
      margin-top: 8px;
      display: block;

      button {
        font-weight: 500;
      }
    }
  }

  .error {
    border: 1px solid red;
  }
  .not-error {
    border: 1px solid transparent;
  }

  ${(props) =>
    !!props.isMultiRoute &&
    css`
      margin-bottom: 0;
    `}
`;
